/** @format */

import React, { Component } from 'react';
import { Menu, Button, Icon } from 'semantic-ui-react';
import { withRouter } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import intl from 'react-intl-universal';
import './NewEditRequestToolbar.css';
import isRestrictedUser from '../../../../helpers/isRestrictedUser';

@inject('UserStore', 'RequestsStore', 'ClientsStore', 'SalesStore')
@observer
class NewEditRequestToolbar extends Component {
  renderActionButtons() {
    const { RequestsStore } = this.props;

    if (RequestsStore.requestsParams.currentRequestId === null) {
      return [
        this.renderAutoManagementButton(),
        this.renderSendRequestButton(),
      ];
    }
  }

  renderAutoManagementButton() {
    const { RequestsStore, ClientsStore } = this.props;
    return (
      <Menu.Item key="auto-management-action">
        <Button
          loading={RequestsStore.requestsParams.saving}
          size="small"
          onClick={() => {
            RequestsStore.handleRequestSave('auto_management', null, () => {
              RequestsStore.resetCurrentRequest();
              this.props.history.push('/requests');
            });
          }}
          color="blue"
          disabled={
            !RequestsStore.hasReqParts ||
            !ClientsStore.clientsParams.clientLoaded ||
            RequestsStore.requestsParams.saving
          }
        >
          <Icon name="sync" />
          {intl.get('requests.auto_management')}
        </Button>
      </Menu.Item>
    );
  }

  renderSendRequestButton() {
    const { RequestsStore, ClientsStore, UserStore } = this.props;
    const isRestricted = isRestrictedUser(
      UserStore.user ? UserStore.user.email : null,
    );
    return (
      <Menu.Item key="send-request-action">
        <Button
          loading={RequestsStore.requestsParams.saving}
          size="small"
          onClick={() => {
            RequestsStore.handleRequestSave('new', null, () => {
              RequestsStore.resetCurrentRequest();
              this.props.history.push('/requests');
            });
          }}
          color="green"
          disabled={
            !RequestsStore.hasReqParts ||
            !ClientsStore.clientsParams.clientLoaded ||
            RequestsStore.requestsParams.saving ||
            isRestricted
          }
        >
          <Icon name="send" />
          {intl.get('requests.send_request')}
        </Button>
      </Menu.Item>
    );
  }

  renderSellerButtons() {
    const { RequestsStore, ClientsStore, SalesStore } = this.props;
    if (RequestsStore.progress === 'auto gestione') {
      return [
        <Menu.Item key="send-to-warehouse">
          <Button
            size="small"
            loading={RequestsStore.requestsParams.saving}
            onClick={() => {
              RequestsStore.handleRequestSave(
                'send_to_warehouse',
                RequestsStore.requestsParams.currentRequestId,
                () => {
                  RequestsStore.resetCurrentRequest();
                  this.props.history.push('/requests');
                },
              );
            }}
            color="yellow"
            disabled={
              !RequestsStore.hasReqParts || RequestsStore.requestsParams.saving
            }
          >
            <Icon name="send" />
            {intl.get('requests.send_to_warehouse')}
          </Button>
        </Menu.Item>,
        <Menu.Item key="auto-checked">
          <Button
            size="small"
            loading={RequestsStore.requestsParams.saving}
            onClick={() => {
              RequestsStore.handleRequestSave(
                'auto_checked',
                RequestsStore.requestsParams.currentRequestId,
                () => {
                  RequestsStore.resetCurrentRequest();
                  this.props.history.push('/requests');
                },
              );
            }}
            color="green"
            disabled={
              !RequestsStore.hasReqParts || RequestsStore.requestsParams.saving
            }
          >
            <Icon name="check" />
            {intl.get('requests.check_finished')}
          </Button>
        </Menu.Item>,
      ];
    }
    if (
      (RequestsStore.isChecked &&
        RequestsStore.progress === 'controllo terminato') ||
      (RequestsStore.isChecked &&
        RequestsStore.progress === 'contrattazione vendita')
    ) {
      const submitAction = !RequestsStore.hasOptionsAvailable
        ? 'notAvailable'
        : 'unsolded';
      const submitText = !RequestsStore.hasOptionsAvailable
        ? intl.get('parts.not_available')
        : intl.get('parts.unsolded');

      return [
        <Menu.Item key="not-sold-button">
          <Button
            size="small"
            onClick={() => {
              RequestsStore.handleRequestSave(
                submitAction,
                RequestsStore.requestsParams.currentRequestId,
                () => {
                  RequestsStore.resetCurrentRequest();
                  this.props.history.push('/requests');
                },
              );
            }}
            color="orange"
            disabled={
              RequestsStore.currentRequest.soldOptions === undefined ||
              Object.values(RequestsStore.currentRequest.soldOptions).length !==
                0
            }
          >
            <Icon name="cancel" />
            {submitText}
          </Button>
        </Menu.Item>,
        <Menu.Item key="complete-sold-button">
          <Button
            size="small"
            onClick={() => {
              SalesStore.openSaleForm(
                RequestsStore.requestsParams.currentRequestsId,
              );
            }}
            color="green"
            disabled={
              (RequestsStore.currentRequest.soldOptions !== undefined &&
                Object.values(RequestsStore.currentRequest.soldOptions)
                  .length === 0) ||
              (ClientsStore.currentClient.addresses !== undefined &&
                Object.keys(ClientsStore.currentClient.addresses).length ===
                  0 &&
                RequestsStore.currentRequest.data.reqShippingType ===
                  'spedizione')
            }
          >
            <Icon name="dollar sign" />
            {intl.get('requests.end_sale')}
          </Button>
        </Menu.Item>,
      ];
    }
    if (
      (RequestsStore.progress === 'inoltrata al magazzino' &&
        RequestsStore.isActive) ||
      (RequestsStore.progress === 'verifica magazzino' &&
        RequestsStore.isActive) ||
      (!RequestsStore.isChecked && RequestsStore.isActive)
    ) {
      return (
        <Menu.Item key="save-button">
          <Button
            loading={RequestsStore.requestsParams.saving}
            size="small"
            onClick={() => {
              RequestsStore.handleRequestSave(
                'update',
                RequestsStore.requestsParams.currentRequestId,
                () => {
                  RequestsStore.resetCurrentRequest();
                  this.props.history.push('/requests');
                },
              );
            }}
            color="green"
            disabled={
              !RequestsStore.hasReqParts || RequestsStore.requestsParams.saving
            }
          >
            <Icon name="save" />
            {intl.get('requests.save_updates')}
          </Button>
        </Menu.Item>
      );
    }
  }

  renderWarehouseButtons() {
    const { RequestsStore } = this.props;

    if (RequestsStore.isChecked) {
      return (
        <Menu.Item key="check-finished">
          <Button
            size="small"
            loading={RequestsStore.requestsParams.saving}
            onClick={() => {
              RequestsStore.handleRequestSave(
                'checked',
                RequestsStore.requestsParams.currentRequestId,
                () => {
                  RequestsStore.resetCurrentRequest();
                  this.props.history.push('/requests');
                },
              );
            }}
            color="green"
            disabled={
              !RequestsStore.hasReqParts || RequestsStore.requestsParams.saving
            }
          >
            <Icon name="check" />
            {intl.get('requests.check_finished')}
          </Button>
        </Menu.Item>
      );
    } else {
      return (
        <Menu.Item key="save-check">
          <Button
            loading={RequestsStore.requestsParams.saving}
            size="small"
            onClick={() => {
              RequestsStore.handleRequestSave(
                'checkSave',
                RequestsStore.requestsParams.currentRequestId,
                () => {
                  RequestsStore.resetCurrentRequest();
                  this.props.history.push('/requests');
                },
              );
            }}
            color="orange"
            disabled={
              !RequestsStore.hasReqParts || RequestsStore.requestsParams.saving
            }
          >
            <Icon name="save" />
            {intl.get('requests.save_check')}
          </Button>
        </Menu.Item>
      );
    }
  }

  renderCompleteButtons() {
    const { RequestsStore } = this.props;

    return (
      <Menu.Item key="see-related-sell">
        <Button
          size="small"
          onClick={() => {
            this.props.history.push(
              '/sales/' +
                RequestsStore.requestsParams.currentRequestId +
                '/view',
            );
            RequestsStore.resetCurrentRequest();
          }}
          color="green"
          disabled={
            !RequestsStore.hasReqParts || RequestsStore.requestsParams.saving
          }
        >
          <Icon name="dollar sign" />
          {intl.get('requests.see_related_sell')}
        </Button>
      </Menu.Item>
    );
  }

  renderButtons = () => {
    const { UserStore, RequestsStore } = this.props;
    if (RequestsStore.requestsParams.currentRequestId === null) {
      return this.renderActionButtons();
    } else {
      if (UserStore.isSeller && RequestsStore.isActive) {
        return this.renderSellerButtons();
      }
      if (UserStore.isWarehouse && RequestsStore.isActive) {
        return this.renderWarehouseButtons();
      }
      if (RequestsStore.progress === 'completata con vendita') {
        return this.renderCompleteButtons();
      }
    }
  };

  renderBackButton = () => {
    const { RequestsStore, ClientsStore, SalesStore } = this.props;
    let backButton = null;
    if (RequestsStore.requestsParams.currentRequestId) {
      backButton = (
        <Menu.Item key="back-button">
          <Button
            className={
              RequestsStore.requestsParams.hasChanged &&
              RequestsStore.currentRequest.data.progress !==
                'contrattazione vendita'
                ? 'disabled'
                : null
            }
            size="small"
            onClick={() => {
              RequestsStore.resetCurrentRequest();
              ClientsStore.resetCurrentClient();
              SalesStore.resetCurrentSale();
              this.props.history.push('/requests');
            }}
            color="red"
          >
            <Icon name="arrow left" />
            {intl.get('requests.back_to_requests')}
          </Button>
        </Menu.Item>
      );
    } else {
      backButton = (
        <Menu.Item key="back-button">
          <Button
            size="small"
            onClick={() => {
              if (RequestsStore.requestsParams.hasChanged) {
                RequestsStore.toggleLeaveRequestModal();
              } else {
                RequestsStore.toggleLeaveRequestModal();
                RequestsStore.resetCurrentRequest();
                ClientsStore.resetCurrentClient();
                SalesStore.resetCurrentSale();
                this.props.history.push('/requests');
              }
            }}
            color="red"
          >
            <Icon name="arrow left" />
            {intl.get('requests.back_to_requests')}
          </Button>
        </Menu.Item>
      );
    }

    // TODO: Decommentare per riattivare il button "Salva senza inoltrare"
    // if (RequestsStore.requestsParams.currentRequestId) {
    //   return [
    //     backButton,
    //     <Menu.Item key="save-and-back-button">
    //       <Button
    //         size="small"
    //         onClick={() => {
    //           this.props.history.push("/requests");
    //         }}
    //         color="blue"
    //       >
    //         <Icon name="save" />
    //         {intl.get("requests.save_and_back")}
    //       </Button>
    //     </Menu.Item>
    //   ];
    // }

    return backButton;
  };

  handleDuplicationClick() {
    // const { RequestsStore, UserStore } = this.props;
    // RequestsStore.loadCurrentRequest(
    //   this.props.match.params.requestId,
    //   UserStore.user.role,
    //   true,
    // );
  }

  render() {
    const { RequestsStore } = this.props;

    return (
      <Menu className="newEditRequest-toolbar" borderless size="small">
        <Menu.Menu position="right">
          <Menu.Item key="print-button">
            <Button
              size="small"
              onClick={() => {
                if (RequestsStore.currentRequest.data.hasBeenPrinted) {
                  RequestsStore.openHasBeenPrintedModal();
                } else {
                  RequestsStore.printRequest();
                }
              }}
              color="black"
            >
              <Icon name="print" />
              {intl.get('general.print')}
            </Button>
          </Menu.Item>
          {this.renderBackButton()}
          {this.renderButtons()}
        </Menu.Menu>
      </Menu>
    );
  }
}

export default withRouter(NewEditRequestToolbar);
